import { Icon } from "@chakra-ui/react";

const DocumentMonoIcon = (props: any) => (
  <Icon viewBox="0 0 18 18" {...props}>
    <path
      id="Vector"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.2627 10.2213C5.2627 10.0821 5.37554 9.96927 5.51476 9.96927H12.2416C12.3808 9.96927 12.4936 10.0821 12.4936 10.2213C12.4936 10.3606 12.3808 10.4734 12.2416 10.4734H5.51476C5.37554 10.4734 5.2627 10.3606 5.2627 10.2213Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      id="Vector_2"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.2627 12.4633C5.2627 12.3241 5.37554 12.2112 5.51476 12.2112H12.2416C12.3808 12.2112 12.4936 12.3241 12.4936 12.4633C12.4936 12.6025 12.3808 12.7154 12.2416 12.7154H5.51476C5.37554 12.7154 5.2627 12.6025 5.2627 12.4633Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      id="Vector_3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.2627 14.7056C5.2627 14.5663 5.37554 14.4535 5.51476 14.4535H12.2416C12.3808 14.4535 12.4936 14.5663 12.4936 14.7056C12.4936 14.8448 12.3808 14.9576 12.2416 14.9576H5.51476C5.37554 14.9576 5.2627 14.8448 5.2627 14.7056Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      id="Vector_4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.02051 1.25207C3.02051 1.11285 3.13336 1 3.27257 1H9.99936C10.0662 1 10.1304 1.02656 10.1776 1.07384L14.6619 5.55853C14.7091 5.60579 14.7357 5.6699 14.7357 5.73674V16.928C14.7357 17.0673 14.6228 17.1801 14.4836 17.1801H3.27257C3.13336 17.1801 3.02051 17.0673 3.02051 16.928V1.25207ZM3.52464 1.50413V16.676H14.2315V5.84114L9.89496 1.50413H3.52464Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      id="Vector_5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99914 1C10.1384 1 10.2512 1.11285 10.2512 1.25207V5.48467H14.4834C14.6226 5.48467 14.7354 5.59751 14.7354 5.73674C14.7354 5.87596 14.6226 5.9888 14.4834 5.9888H9.99914C9.85991 5.9888 9.74707 5.87596 9.74707 5.73674V1.25207C9.74707 1.11285 9.85991 1 9.99914 1Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </Icon>
);

export default DocumentMonoIcon;
